import * as zod from "zod/v4";
import {
  CampaignFilterConditionSchema,
  CampaignScheduleSchema,
  CampaignSlackDestinationSchema,
} from "./get-campaigns";

export const updateCampaign = {
  name: "updateCampaign" as const,
  input: zod.object({
    campaignId: zod.string(),
    name: zod.string().optional(),
    description: zod.string().optional(),
    filters: zod.array(CampaignFilterConditionSchema).optional(),
    filterLogic: zod.enum(["and", "or"]).optional(),
    schedule: CampaignScheduleSchema.optional(),
    messageStyle: zod.enum(["individual", "digest"]).optional(),
    destination: CampaignSlackDestinationSchema.optional(),
    isActive: zod.boolean().optional(),
  }),
  output: zod.object({ success: zod.boolean() }),
};
